import { render } from "./OrderItemsTable.vue?vue&type=template&id=46ad2992"
import script from "./OrderItemsTable.vue?vue&type=script&lang=ts"
export * from "./OrderItemsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script